export interface WidgetTheme {
  // Base colors
  primaryColor: string;
  backgroundColor: string;
  textColor: string;
  secondaryTextColor: string;
  borderColor: string;
  
  // Component specific
  headerBackground: string;
  dateNavBackground: string;
  dateNavTextColor: string;
  activeDateBackground: string;
  buttonTextColor: string;
  dividerColor: string;
  
  // Dialog specific
  dialogBackgroundColor: string;
  dialogOverlayColor: string;
  dialogHeaderColor: string;
  dialogTextColor: string;
  dialogBorderColor: string;
}

export const lightTheme: WidgetTheme = {
  // Base colors
  primaryColor: '#c41230',
  backgroundColor: '#ffffff',
  textColor: '#1a1a3c',
  secondaryTextColor: '#666666',
  borderColor: '#eaedf2',
  
  // Component specific
  headerBackground: '#ffffff',
  dateNavBackground: '#1a1a3c',
  dateNavTextColor: '#ffffff',
  activeDateBackground: 'rgba(255, 255, 255, 0.15)',
  buttonTextColor: '#ffffff',
  dividerColor: '#eaedf2',
  
  // Dialog specific
  dialogBackgroundColor: '#ffffff',
  dialogOverlayColor: 'rgba(0, 0, 0, 0.5)',
  dialogHeaderColor: '#1a1a3c',
  dialogTextColor: '#1a1a3c',
  dialogBorderColor: '#eaedf2'
};

export const darkTheme: WidgetTheme = {
  // Base colors
  primaryColor: '#1a1a3c',
  backgroundColor: '#1a1a3c',
  textColor: '#ffffff',
  secondaryTextColor: 'rgba(255, 255, 255, 0.7)',
  borderColor: 'rgba(255, 255, 255, 0.1)',
  
  // Component specific
  headerBackground: '#141428',
  dateNavBackground: '#141428',
  dateNavTextColor: '#ffffff',
  activeDateBackground: 'rgba(255, 255, 255, 0.15)',
  buttonTextColor: '#ffffff',
  dividerColor: 'rgba(255, 255, 255, 0.1)',
  
  // Dialog specific
  dialogBackgroundColor: '#1a1a3c',
  dialogOverlayColor: 'rgba(0, 0, 0, 0.7)',
  dialogHeaderColor: '#ffffff',
  dialogTextColor: '#ffffff',
  dialogBorderColor: 'rgba(255, 255, 255, 0.1)'
}; 